import { Link } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";
import CustomSVG from '../../assets/img/customizeSVG';
import { openWhatsAppChat } from '../../util/whatsappUtils';

const handleWhatsApp = (e) => {
	e.stopPropagation();
	openWhatsAppChat('Hi, I would like to know more about your properties and services.');
};


const Footer = () => {
	let publicUrl = process.env.PUBLIC_URL + "/";

	return (
		<footer className="footer-area style-two" style={{ paddingTop: '60px', paddingBottom: '20px' }}>
			<div className="footer-top px-4" style={{ paddingBottom: '40px' }}>
				<div className="container-fluid">
					<div className="row">
						{/* Logo and Description */}
						<div className="col-12 col-md-3 col-sm-6" style={{ paddingLeft: "1rem" }}>
							<a href="/" style={{ display: 'inline-block', marginBottom: '15px' }}>
								<CustomSVG className="desktop-logo" />
							</a>
							<p className="text-white" style={{ fontSize: '14px', lineHeight: '1.6' }}>
								{/* Royale Spaces UK-Based Real Estate Company Now in Hyderabad & Amaravati. */}
								Royale Spaces is a top real estate company delivering trusted residential and commercial projects in Amaravati and Hyderabad.
							</p>
						</div>

						{/* Services */}
						<div className="col-12 col-md-2 col-sm-6" style={{ paddingLeft: "1rem" }}>
							<h4 className="widget-title">Services</h4>
							<div className="quick-links">
								{[
									{ label: "Commercial", path: "/commercial-plots-for-sale-in-amaravati" },
									{ label: "Residential", path: "/residential-plots-for-sale-in-amaravati" },
									// { label: "Villa Plots", path: "/villa-plots" },
									{ label: "Agricultural lands", path: "/agriculture-lands-for-sale-in-amaravati" },
								].map((link, index) => (
									<p key={index} style={{ marginBottom: '0' }}>
										<Link className="text-white" to={link.path}>
											{link.label}
										</Link>
									</p>
								))}
							</div>
						</div>

						{/* About */}
						<div className="col-12 col-md-2 col-sm-6" style={{ paddingLeft: "1rem" }}>
							<h4 className="widget-title">About</h4>
							<div className="quick-links">
								{[
									{ label: "Contact Us", path: "/contact" },
									{ label: "Customer Reviews", path: "/customer-reviews" },
									{ label: "Amaravati News", path: "/amaravati-news" },
									{ label: "Hyderabad News", path: "/hyderabad-news" },
								].map((link, index) => (
									<p key={index} style={{ marginBottom: '0' }}>
										<Link className="text-white" to={link.path}>
											{link.label}
										</Link>
									</p>
								))}
							</div>
						</div>

						{/* Contact Us */}
						<div className="col-12 col-md-3 col-sm-6" style={{ paddingLeft: "1rem" }}>
							<h4 className="widget-title">Contact Us</h4>
							<p className="text-white">
								<img src={`${publicUrl}assets/img/icon/phone.png`} alt="phone icon" style={{ width: '20px', marginRight: '8px' }} />
								<a href="tel:+917893092211" style={{ color: '#000', fontSize: '14px' }}>+91 78930 92211</a>
							</p>
							<p className="text-white" onClick={handleWhatsApp}>
								<img src={`${publicUrl}assets/img/icon/whatsapp.png`} alt="phone icon" style={{ width: '20px', height: '20px', marginRight: '8px' }} />
								<a href="tel:+917893092211" style={{ color: '#000', fontSize: '14px' }}>+91 78930 92211</a>
							</p>
							<p className="text-white">
								<img src={`${publicUrl}assets/img/icon/envelope.png`} alt="email icon" style={{ width: '20px', marginRight: '8px' }} />
								<a href="mailto:info@royalespaces.com" style={{ color: '#000', fontSize: '14px' }}>info@royalespaces.com</a>
							</p>
						</div>

						{/* Follow Us */}
						<div className="col-12 col-md-2 col-sm-6" style={{ paddingLeft: "1rem" }}>
							<h4 className="widget-title">Follow Us</h4>
							<div className="widget widget_about d-flex ps-0">
								{[
									{
										platform: "facebook", url: "https://www.facebook.com/profile.php?id=61571816318492"
									},
									{
										platform: "twitter", url: "https://x.com/RoyaleSpaces", icon: true
									},
									{
										platform: "instagram", url: "https://www.instagram.com/royalespaces/"
									},
									{
										platform: "youtube",
										url: "https://www.youtube.com/@RoyaleSpaces",
									},
								].map((social, index) => {
									let marginTop = 0;
									if (social.platform === "facebook") marginTop = "2px";
									if (social.platform === "instagram") marginTop = "2px";
									if (social.platform === "youtube") marginTop = "2px";

									return (
										<p key={index} style={{ marginTop }}>
											<a href={social.url} style={{ color: "#d8b035" }} target="_blank"
												rel="noopener noreferrer">
												{social.icon ? (
													<i><FaXTwitter /></i>
												) : (
													<i className={`fab fa-${social.platform}`} aria-hidden="true" />
												)}
											</a>
										</p>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="footer-bottom">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 navLinks">
							<ul>
								{[
									{ label: "Terms of use", path: "/terms-conditions" },
									{ label: "Privacy policy", path: "/privacy-policy" },
									{ label: "Cookie policy", path: "/cookies-policy" },
								].map((link, index) => (
									<li key={index}>
										<Link className="text-white" to={link.path}>
											{link.label}
										</Link>
									</li>
								))}
							</ul>
						</div>
						<div className="col-lg-6 copyWrite">
							<p>©Royale Spaces (India) Private Limited 2025</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
